export const positionMap: Record<
  "bottom-right" | "bottom-left" | "top-right" | "top-left",
  string
> = {
  "bottom-right": "tvw-bottom-6 tvw-right-6",
  "bottom-left": "tvw-bottom-6 tvw-left-6",
  "top-right": "tvw-top-6 tvw-right-6",
  "top-left": "tvw-top-6 tvw-left-6"
};








